import { Outlet, createBrowserRouter } from 'react-router-dom'

import { useUserInfo } from '../hooks/useUserInfo'

import { SignUp } from '../pages/auth/SignUp'
import { Layout } from '../pages/Layout'

import { Catalog } from '../pages/catalog/Catalog'

import { PUBLIC_ROUTES } from './publicRoutes'
import { PROTECTED_ROUTES } from './protectedRoutes'

function RequiredUserInfo() {
  const { data: userInfo } = useUserInfo()

  const isNeedUserData = userInfo?.status === 'NEED_REQUIRE_DATA_INPUT'

  return isNeedUserData ? <SignUp /> : <Outlet />
}

export const router = createBrowserRouter([
  {
    path: '/catalog/:uriKey',
    element: <Catalog />,
  },
  {
    element: <Layout />,
    errorElement: <Layout isError={true} />,
    children: [
      {
        element: <RequiredUserInfo />,
        children: [...PUBLIC_ROUTES, ...PROTECTED_ROUTES],
      },
    ],
  },
])
